import {
  CURRENT_CUSTOM_EVENTS_STORED,
  CUSTOM_EVENTS_STORED,
  TOTAL_CUSTOM_EVENTS_HIGH_WATERMARK,
} from 'modules/billing/constants';
import { useBillingQueryContext } from 'modules/billing/contexts';
import { createHighWatermarkCaption, yesterdayDisplay } from 'modules/billing/utils';
import { LoadingCard } from '../LoadingCard';
import { MetricRow } from '../MetricRow';
import { MetricTile } from '../MetricTile';
import { ProjectBreakdownLink } from '../ProjectBreakdownLink';
import { Container, Header, MainContent, Marquee, RowsWrapper, Title } from '../styled';
import { CUSTOM_EVENTS_CARD_IDS, CUSTOM_EVENTS_CARD_TEXT } from './constants';

const {
  cardTitle,
  projectBreakdownUrl,
  totalCustomEventsDescription,
  totalCustomEventsHighWatermarkDescription,
  totalCustomEventsHighWatermarkName,
} = CUSTOM_EVENTS_CARD_TEXT;

export const CustomEventsCard = () => {
  const { pickOrgMetric, pickOrgValue, displayEndDate, displayDateRange, isLoading } =
    useBillingQueryContext();

  const customEventsHighWatermark = pickOrgMetric(TOTAL_CUSTOM_EVENTS_HIGH_WATERMARK);
  const totalCustomEvents = pickOrgValue(CUSTOM_EVENTS_STORED);
  const totalCustomEventsHighWatermark = pickOrgValue(TOTAL_CUSTOM_EVENTS_HIGH_WATERMARK);

  return isLoading ? (
    <LoadingCard />
  ) : (
    <Container data-test={CUSTOM_EVENTS_CARD_IDS.cardId}>
      <Header>
        <Title>{cardTitle}</Title>
        <div>
          <ProjectBreakdownLink to={projectBreakdownUrl} />
        </div>
      </Header>
      <Marquee>
        <MetricTile
          label="Current"
          tooltip="Total number of custom events currently stored across all projects"
          caption={`As of ${yesterdayDisplay()}`}
          value={pickOrgValue(CURRENT_CUSTOM_EVENTS_STORED)}
        />
      </Marquee>
      <MainContent>
        <RowsWrapper>
          <MetricRow
            label="Custom events stored"
            caption={`As of ${displayEndDate}`}
            tooltip={`${totalCustomEventsDescription} ${displayEndDate}`}
            value={totalCustomEvents}
          />
          <MetricRow
            label={totalCustomEventsHighWatermarkName}
            caption={
              customEventsHighWatermark ? createHighWatermarkCaption(customEventsHighWatermark) : ''
            }
            tooltip={`${totalCustomEventsHighWatermarkDescription} ${displayDateRange}`}
            value={totalCustomEventsHighWatermark}
          />
        </RowsWrapper>
      </MainContent>
    </Container>
  );
};
